/* eslint-disable no-script-url */
/* eslint-disable no-useless-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-const */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-access-state-in-setstate */
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { Card, CardBody, Col, Row, } from 'reactstrap';
import { mdiClose, mdiMagnify } from '@mdi/js';
import { regions_communes } from './Json_Regiones_y_Comunas';
import { connect } from 'react-redux';
import NumberFormat from 'react-currency-format';
import QueryString from 'query-string';
import TableCell from '@material-ui/core/TableCell';
import remove from 'lodash/remove';
import moment from 'moment';
import find from 'lodash/find';
import Icon from '@mdi/react';
import map from 'lodash/map';
import { getRegions, getCommuns } from '../../../redux/actions/resourcesActions';
import { changeTitleAction } from '../../../redux/actions/topbarActions';
import {
  createContacts,
  getContacts,
  updateContact,
  deleteUser,
  generatePass,
  getContactData,
  updateContactData,
  resetContactData
} from '../../../redux/actions/contactosActions';
import DModal from '../../../shared/components/Modal/Modal';
import FModal from '../../../shared/components/Modal/ModalFiltersContacts';
import { setRUTFormat, isUserAllowed, findFullName } from '../../../shared/utils';
import { updateCase, updateCaseMe } from '../../../redux/actions/casesActions';
import BasicNotification from '../../../shared/components/Notifications/BasicNotification';
import MatTable from '../../../shared/components/MaterialTable';
import ModalGeneratePass from './ModalGeneratePass';
import ContactModal from './ContactModal';
import { ROLES } from '../../../helper/constants';

const headers = [
  {
    id: 'rut', disablePadding: true, label: 'RUT',
  },
  {
    id: 'name', disablePadding: true, label: 'Nombre',
  },
  {
    id: 'phone', disablePadding: false, label: 'Teléfono',
  },
  {
    id: 'email', disablePadding: false, label: 'Email',
  },
  {
    id: 'rent', disablePadding: false, label: 'Renta',
  },
  {
    id: 'actions', disablePadding: false, label: 'Acciones',
  },
];

const contactDataInitial = {
  rut: '',
  phone: '',
  mail: '',
  pass: '',
  exists: false,
};

export class ContactContent extends Component {
  state = {
    isOpenModalC: false,
    isOpenModalD: false,
    isOpenModalF: false,
    isOpenModalGP: false,
    names: '',
    paternalSurname: '',
    maternalSurname: '',
    companyName: '',
    userSII: '',
    passwordSII: '',
    pass: '',
    emails: [],
    rent: 0,
    birthdate: null,
    rut: '',
    phones: [],
    addresses: [],
    tooltipOpen: false,
    profile: null,
    nationality: null,
    sex: null,
    civilStatus: null,
    selected: [],
    search: null,
    type: { value: 'dependent', label: 'Dependiente' },
    page: 0,
    rowsPerPage: 10,
    dropdownOpen: false,
    communes: [],
    valueToFilter: {
      nationalities: null,
      sexes: null,
      civilStates: null
    },
    contactDataToUpdate: contactDataInitial,
  };

  componentDidMount() {
    this.props.changeTitleAction('Contactos');
    let {
      page = 1, limit = 10, newContact = false, rut = '', search,
    } = QueryString.parse(this.props.location.search);
    const query = {};
    if (page && !Number.isNaN(page)) {
      page = parseInt(page, 10) - 1;
      Object.assign(query, { page: page + 1 });
    }
    if (limit && !Number.isNaN(limit)) {
      limit = parseInt(limit, 10);
      Object.assign(query, { limit });
    }

    if (newContact) {
      this.setState({ rut });
      this.onClickContacto();
    }
    this.setState({ page, rowsPerPage: limit });
    this.props.getContacts({ ...query, search });
  }

  componentWillUnmount() {
    this.props.changeTitleAction('');
  }

  toggle = () => {
    const { fromCases = false } = QueryString.parse(this.props.location.search);
    const { fromDetailsCase = false, idCase } = QueryString.parse(this.props.location.search);
    const { fromQuotations = false } = QueryString.parse(this.props.location.search);
    const { rut } = this.state;
    if (fromCases) {
      this.props.history.push(`/casos?rut=${rut}`);
    }
    if (fromDetailsCase) {
      this.props.history.push(`/casos/${idCase}`);
    }
    if (fromQuotations) {
      this.props.history.push(`/cotizaciones?rut=${rut}`);
    }
    this.setState({ isOpenModalC: false });
  }

  onClickContacto = () => {
    let {
      rut = null,
      newContact,
      fromDetailsCase,
      clientEmail,
    } = QueryString.parse(this.props.location.search);
    if (rut) {
      this.setState({
        isOpenModalC: true,
        _id: null,
        names: '',
        paternalSurname: '',
        maternalSurname: '',
        companyName: '',
        userSII: '',
        passwordSII: '',
        emails: [],
        rent: 0,
        birthdate: null,
        rut,
        type: { value: 'dependent', label: 'Dependiente' },
        phones: [],
        addresses: [],
        profile: null,
        nationality: { value: 1, label: 'Chilena' },
        sex: null,
        civilStatus: null,
        communes: [],
      });
    } else {
      this.setState({
        isOpenModalC: true,
        _id: null,
        names: '',
        paternalSurname: '',
        maternalSurname: '',
        companyName: '',
        userSII: '',
        passwordSII: '',
        emails: [],
        rent: 0,
        birthdate: null,
        rut: '',
        type: { value: 'dependent', label: 'Dependiente' },
        phones: [],
        addresses: [],
        profile: null,
        nationality: { value: 1, label: 'Chilena' },
        sex: null,
        civilStatus: null,
        communes: [],
      });
    }
    if ((newContact !== undefined) && (fromDetailsCase !== undefined) && (clientEmail !== undefined)) {
      const mail = [{
        email: clientEmail,
        fromTrinidad: false,
        status: true,
      }];
      this.setState({ emails: mail });
    }
  }

  onClickDeleteContacto = contact => () => {
    this.setState({ isOpenModalD: true, contact });
  }

  onClickPass = () => {
    this.setState({ isOpenModalGP: true });
    this.props.resetContactData();
  }

  toggleGP = () => {
    this.setState({ isOpenModalGP: false });
    this.setState({ pass: '' });
    this.setContactData(contactDataInitial);
    this.props.resetContactData();
  }

  setContactData = (data) => this.setState({ contactDataToUpdate: data });

  toggleDeleteContacto = isOk => () => {
    if (isOk) {
      this.onDelete();
    } else {
      this.setState({ isOpenModalD: false });
    }
  }

  findElement = (emails) => {
    let findIt = 0;
    for (const search of emails) {
      for (const compare of emails) {
        if (search.email === compare.email) {
          findIt += 1;
        }
      }
      if (findIt > 1) {
        return true;
      }
      findIt = 0;
    }
    return false;
  }

  findElementPhones = (phones) => {
    let findIt = 0;
    for (const phone of phones) {
      const search = phone.number;
      for (const phone2 of phones) {
        const compare = phone2.number;
        if (search === compare) {
          findIt += 1;
        }
      }
      if (findIt > 1) {
        return true;
      }
      findIt = 0;
    }
    return false;
  }

  onSubmit = (e) => {
    e.preventDefault();
    const {
      _id,
      names,
      paternalSurname,
      maternalSurname,
      companyName,
      passwordSII,
      nationality,
      civilStatus,
      birthdate,
      addresses,
      userSII,
      profile,
      emails,
      phones,
      type,
      rent,
      rut,
      sex,
    } = this.state;

    if (addresses.length === 0) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe agregar una dirección',
      });
      return;
    }

    if ((type.value === 'dependent') || (type.value === 'independent')) {
      if (parseInt(rut.replace(/[^K0-9\s]/gi, ''), 10) > 550000000) {
        BasicNotification.show({
          color: 'danger',
          title: 'Atención',
          message: 'No puedes usar rut de empresa en un contacto tipo persona natural.',
        });
        return;
      }
    } else if (parseInt(rut.replace(/[^K0-9\s]/gi, ''), 10) < 550000000) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'No puedes usar rut de persona natural en un contacto tipo empresa.',
      });
      return;
    }

    if (this.findElement(emails)) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Los correos no pueden repetirse.',
      });
      return;
    }

    if (this.findElementPhones(phones)) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Los numeros no pueden repetirse.',
      });
      return;
    }

    if ((phones.length === 0)) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe ingresar al menos un telefono.',
      });
      return;
    }

    if ((emails.length === 0)) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe ingresar al menos un email.',
      });
      return;
    }

    this.sendData({
      _id,
      names: names.trim(),
      paternalSurname: paternalSurname ? paternalSurname.trim() : '',
      maternalSurname: maternalSurname ? maternalSurname.trim() : '',
      companyName: companyName ? companyName.trim() : '',
      userSII: userSII ? userSII.trim() : '',
      rent: String(rent).replace(/[^,0-9\s]/gi, ''),
      rut: rut.replace(/[^K0-9\s]/gi, ''),
      type: type.value,
      passwordSII,
      nationality,
      civilStatus,
      birthdate,
      addresses,
      profile,
      phones,
      emails,
      sex,
    });
  }

  translateContact = (contact) => {
    if (contact === 'dependent') {
      return { value: 'dependent', label: 'Dependiente' };
    }
    if (contact === 'independent') {
      return { value: 'independent', label: 'Inependiente' };
    }
    if (contact === 'company') {
      return { value: 'company', label: 'Empresa' };
    }
    return { value: 'dependent', label: 'Dependiente' };
  }

  onEditar = conact => () => {
    const {
      _id,
      names,
      paternalSurname,
      maternalSurname,
      type,
      companyName,
      userSII,
      passwordSII,
      emails,
      rent,
      birthdate,
      rut,
      phones,
      addresses,
      profile,
      nationality,
      sex,
      civilStatus,
    } = conact;

    this.setState({
      _id,
      names,
      isOpenModalC: true,
      paternalSurname: paternalSurname ? paternalSurname.trim() : '',
      maternalSurname: maternalSurname ? maternalSurname.trim() : '',
      type: this.translateContact(type),
      companyName: companyName ? companyName.trim() : '',
      userSII: userSII ? userSII.trim() : '',
      passwordSII,
      emails,
      rent,
      birthdate: birthdate ? moment(birthdate).toDate() : birthdate,
      rut,
      phones,
      addresses: map(addresses, (address) => {
        if (address.region) {
          const result = find(regions_communes, region => region.value === address.region.value);
          return { ...address, coptions: result.communes };
        }
        return {};
      }),
      profile,
      nationality,
      sex,
      civilStatus,
    });
  }

  onDelete = () => {
    const { contact } = this.state;
    this.props.deleteUser(contact._id, () => {
      this.props.getContacts();
      this.setState({ isOpenModalD: false });
    });
  }

  sendData = (data) => {
    const { fromDetailsCase, idCase } = QueryString.parse(this.props.location.search);
    const isAdmin = isUserAllowed('admin') || isUserAllowed('manager');
    if ((fromDetailsCase !== undefined) && idCase) {
      delete data._id;
      this.props.createContacts(data, (body) => {
        const assignClient = {
          action: 'assignClient',
          payload: {
            client: body._id,
          },
        };

        if (isAdmin) {
          this.props.updateCase(idCase, assignClient, () => {
            this.toggle();
          });
        } else {
          this.props.updateCaseMe(idCase, assignClient, () => {
            this.toggle();
          });
        }
      });
    }

    if (!data._id) {
      delete data._id;
      this.props.createContacts(data, () => {
        this.props.getContacts();
        this.toggle();
      });
    } else {
      this.props.updateContact(data._id, data, () => {
        this.props.getContacts();
        this.toggle();
      });
    }
  }

  onChangePhone = (key, index) => (e) => {
    let value = e.target.value;
    this.setState(prevState => {
      let phones = [...prevState.phones];
      phones[index][key] = value?.replace(/[^0-9\s]/gi, '').trim();
      return { phones };
    });
  }

  onRemove = index => () => {
    this.setState(prevState => {
      let phones = [...prevState.phones];
      remove(phones, (_, i) => i === index);
      return { phones };
    });
  }

  addPhone = () => {
    this.setState(prevState => {
      let phones = [...prevState.phones];
      phones.push({ code: '+56', number: '' });
      return { phones };
    });
  }

  onChangeEmail = (key, index) => (e) => {
    let value = e.target.value;
    this.setState(prevState => {
      let emails = [...prevState.emails];
      emails[index][key] = value;
      return { emails };
    });
  }

  onRemoveEmail = index => () => {
    this.setState(prevState => {
      let emails = [...prevState.emails];
      remove(emails, (_, i) => i === index);
      return { emails };
    });
  }

  addEmail = () => {
    this.setState(prevState => {
      let emails = [...prevState.emails];
      emails.push({ email: '' });
      return { emails };
    });
  }

  onChangeAddress = (key, index) => (e) => {
    let addresses = [...this.state.addresses];

    if (key === 'region') {
      addresses[index][key] = {
        value: e.value,
        label: e.label,
      };
      addresses[index].commune = null;
      this.props.getCommuns({ region: e.value }, (body) => {
        addresses[index].coptions = body;
        this.setState({ addresses });
      });
    } else if (key === 'commune') {
      addresses[index][key] = e;
      this.setState({ addresses });
    } else {
      addresses[index][key] = e.target.value;
      this.setState({ addresses });
    }
  }

  onRemoveAddress = index => () => {
    this.setState(prevState => {
      let addresses = [...prevState.addresses];
      remove(addresses, (_, i) => i === index);
      return { addresses };
    });
  }

  addAddress = () => {
    this.setState(prevState => {
      let addresses = [...prevState.addresses];
      addresses.push({ street: '', commune: null, region: null, copts: [], });
      return { addresses };
    });
  }

  onChangeInput = key => (e) => {
    if (key === 'rut') {
      this.setState({ [key]: setRUTFormat(e.target.value) });
    } else if (key === 'birthdate') {
      this.setState({ [key]: e });
    } else if ((key === 'profile') || (key === 'nationality') || (key === 'sex') || (key === 'civilStatus')) {
      this.setState({ [key]: e });
    } else if ((key === 'rent')) {
      this.setState({ [key]: e.target.value.replace(/[^$0-9\s]/gi, '') });
    } else if ((key === 'type')) {
      this.setState({
        [key]: e,
        names: '',
        paternalSurname: '',
        maternalSurname: '',
        companyName: '',
        userSII: '',
        passwordSII: '',
      });
    } else {
      this.setState({ [key]: e.target.value });
    }
  }

  onChangeSearch = (e) => {
    this.setState({ search: e.target.value });
  }

  onSubmitSearch = (e) => {
    e.preventDefault();
    const { search, } = this.state;
    let query = {};
    Object.assign(query, { search });
    this.props.getContacts(query, () => {
      this.props.history.push(`/contactos?${QueryString.stringify(query)}`);
    });
  }

  onSelectAllClick = (checked) => {
    if (checked) {
      const { contacts } = this.props;
      this.setState({ selected: contacts.map(contact => contact._id) });
      return;
    }
    this.setState({ selected: [] });
  }

  onClickRow = id => () => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    this.setState({ selected: newSelected });
  }

  onChangePage = (page) => {
    this.setState({ page });
    const query = QueryString.parse(this.props.location.search);
    this.props.history.push(`/contactos?${QueryString.stringify({ ...query, page: page + 1 })}`);
    this.props.getContacts({ ...query, page: page + 1 });
  }

  onChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
    const query = QueryString.parse(this.props.location.search);
    this.props.history.push(`/contactos?${QueryString.stringify({ ...query, limit: rowsPerPage })}`);
    this.props.getContacts({ ...query, limit: rowsPerPage });
  }

  onChangeFilter = key => (e) => {
    this.setState(prevState => {
      let valueToFilter = [...prevState.valueToFilter];
      valueToFilter[key] = e;
      return { valueToFilter };
    });
  }

  toFilter = () => {
    const { valueToFilter } = this.state;
    const dataToFilter = {};

    if (valueToFilter.nationalities != null) {
      dataToFilter.nationalities = valueToFilter.nationalities.value;
    }

    if (valueToFilter.sexes != null) {
      dataToFilter.sexes = valueToFilter.sexes.value;
    }

    if (valueToFilter.civilStates != null) {
      dataToFilter.civilStates = valueToFilter.civilStates.value;
    }

    let query = QueryString.parse(this.props.location.search);
    if (dataToFilter) {
      query = {};
    }

    Object.assign(query, dataToFilter);

    this.props.getContacts(query, () => {
      this.props.history.push(`/contactos?${QueryString.stringify(query)}`);
      this.setState({ isOpenModalF: false });
    });
  }

  toggleFilterContacto = isOk => () => {
    if (isOk) {
      this.toFilter();
    } else {
      this.setState({ isOpenModalF: false });
    }
  }

  cleanFilters = () => {
    this.setState({
      valueToFilter: {
        nationalities: null,
        sexes: null,
        civilStates: null,
      },
    });
  }

  AllContacts = () => {
    this.props.getContacts();
    this.setState({ search: '' });
  }

  handleGeneratePass = async () => {
    const { contactDataToUpdate } = this.state;
    await this.props.generatePass({ dni: contactDataToUpdate.rut.replace(/\./g, '') },
      (res, status) => {
        let pass = '';
        if (status === 200) {
          pass = res?.password || '';
        }
        this.setContactData({ ...contactDataToUpdate, pass });
      });
  };

  handleFindContactData = async () => {
    const { contactDataToUpdate } = this.state;
    this.setContactData({ ...contactDataToUpdate, pass: '' });
    await this.props.getContactData(contactDataToUpdate.rut?.replace(/\./g, ''),
      (res, status) => {
        let mail = '', phone = '', exists = false;
        if (status === 200) {
          mail = res?.mail || ''
          phone = res?.phone?.replace(/\+56/g, '') || ''
          exists = true;
        }
        this.setContactData({ ...contactDataToUpdate, mail, phone, pass: '', exists });
      }
    );
  }

  handleUpdatePhone = async (e) => {
    await this.props.updateContactData(e.rut.replace(/\./g, ''), { phone: `+56${e.phone}` });
  }

  handleUpdateEmail = async (e) => {
    await this.props.updateContactData(e.rut.replace(/\./g, ''), { mail: e.mail });
  }

  render() {
    const { selected, page, rowsPerPage } = this.state;
    const { total } = this.props;

    const data = map(this.props.contacts, contact => ({
      id: contact._id,
      cells: (
        <Fragment>
          <TableCell className="material-table__cell" align="left">{setRUTFormat(contact.rut)}</TableCell>
          <TableCell className="material-table__cell" align="left">
            {findFullName(contact)}
          </TableCell>
          <TableCell className="material-table__cell" align="left">{contact.phones.length >= 1 && `${contact.phones[0].code} ${contact.phones[0].number}`}</TableCell>
          <TableCell className="material-table__cell" align="left">{contact.emails.length >= 1 && contact.emails[0].email}</TableCell>
          <TableCell className="material-table__cell" align="left">
            <NumberFormat
              value={contact.rent || 0}
              displayType="text"
              decimalSeparator=","
              thousandSeparator="."
              prefix="$"
            />
          </TableCell>
          <TableCell className="material-table__cell" align="left">
            <button className="crm-edit-button" type='button' onClick={this.onEditar(contact)}>
              <span
                className="lnr lnr-lnr lnr-pencil"
                style={{
                  fontSize: '20px', fontWeight: 'bold', cursor: 'pointer', color: '#000',
                }}
              />
            </button>
            {!isUserAllowed(ROLES.auditor) &&
              <button
                className="crm-edit-button"
                type='button'
                style={{ marginLeft: '10%' }}
                onClick={this.onClickDeleteContacto(contact)}
              >
                <span
                  className="lnr lnr-lnr lnr-trash"
                  style={{
                    fontSize: '20px', fontWeight: 'bold', cursor: 'pointer', color: '#000',
                  }}
                />
              </button>}
          </TableCell>
        </Fragment>),
    }));
    return (
      <div className="dashboard container">
        <ContactModal
          isOpen={this.state.isOpenModalC}
          onChangeAddress={this.onChangeAddress}
          onRemoveAddress={this.onRemoveAddress}
          onChangeInput={this.onChangeInput}
          onChangePhone={this.onChangePhone}
          onChangeEmail={this.onChangeEmail}
          onRemoveEmail={this.onRemoveEmail}
          addAddress={this.addAddress}
          onRemove={this.onRemove}
          addEmail={this.addEmail}
          addPhone={this.addPhone}
          onSubmit={this.onSubmit}
          toggle={this.toggle}
          disableButtonCreate={this.props.creatting}
          value={this.state}
        />
        <ModalGeneratePass
          handleFindContactData={this.handleFindContactData}
          handleGeneratePass={this.handleGeneratePass}
          handleUpdatePhone={this.handleUpdatePhone}
          handleUpdateEmail={this.handleUpdateEmail}
          setContactData={this.setContactData}
          toggle={this.toggleGP}
          contactDataToUpdate={this.state.contactDataToUpdate}
          updatedContactData={this.props.updatedContactData}
          contactData={this.props.contactData}
          loading={this.props.loading}
          values={this.state}
        />
        <DModal
          title="Atención"
          color="warning"
          message="¿Esta seguro que desea borrar este registro?"
          isOpen={this.state.isOpenModalD}
          toggle={this.toggleDeleteContacto}
        />
        <FModal
          title="Filtrar"
          color="warning"
          message="¿Esta seguro que desea borrar este registro?"
          isOpen={this.state.isOpenModalF}
          toggle={this.toggleFilterContacto}
          onChangeFilter={this.onChangeFilter}
          cleanFilters={this.cleanFilters}
          valueToFilter={this.state.valueToFilter}
        />
        <Card style={{ paddingBottom: '10px' }}>
          <CardBody className="card_body_flex" style={{ padding: '10px' }}>
            <Col md="8" className='crm-col-container'>
              <form
                className='crm-form-container'
                onSubmit={this.onSubmitSearch}
              >
                <div className='crm-search-input-container'>
                  <Icon path={mdiMagnify} size={1} />
                  <input
                    onChange={this.onChangeSearch}
                    value={this.state.search}
                    placeholder="Nombre o RUT cliente"
                  />
                  <button
                    type="button"
                    onClick={this.AllContacts}
                    disabled={!this.state.search}
                  >
                    <Icon path={mdiClose} />
                  </button>
                </div>
              </form>
            </Col>

            {!isUserAllowed(ROLES.auditor) && <Col md="4" style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Col xs="auto" sm="auto" md="auto">
                <button
                  type="button"
                  className={`button-dark ${this.props.cargando && 'button-dark-disabled'}`}
                  onClick={this.onClickPass}
                  style={{ margin: '10px 10px' }}
                  disabled={this.props.cargando}
                >
                  Datos de Portal Clientes
                </button>
                <button
                  type="button"
                  className={`button-dark ${this.props.cargando && 'button-dark-disabled'}`}
                  onClick={this.onClickContacto}
                  style={{ margin: '10px 10px' }}
                  disabled={this.props.cargando}
                >
                  Nuevo Contacto
                </button>
              </Col>
            </Col>}
          </CardBody>
        </Card>
        <Row>
          <MatTable
            onSelectAllClick={this.onSelectAllClick}
            onChangePage={this.onChangePage}
            cargando={this.props.cargando}
            onChangeRowsPerPage={this.onChangeRowsPerPage}
            onClickRow={this.onClickRow}
            selected={selected}
            headers={headers}
            data={data}
            page={page}
            rowsPerPage={rowsPerPage}
            total={total}
          />
        </Row>
      </div>
    );
  }
}

ContactContent.propTypes = {
  creatting: PropTypes.bool,
  cargando: PropTypes.bool,
  loading: PropTypes.bool,
  total: PropTypes.string,
  updatedContactData: PropTypes.shape({
    loading: PropTypes.bool,
    message: PropTypes.string,
  }),
  contactData: PropTypes.object,
  contacts: PropTypes.array,
  updateCase: PropTypes.func,
  getCommuns: PropTypes.func,
  deleteUser: PropTypes.func,
  getContacts: PropTypes.func,
  updateCaseMe: PropTypes.func,
  generatePass: PropTypes.func,
  updateContact: PropTypes.func,
  getContactData: PropTypes.func,
  createContacts: PropTypes.func,
  resetContactData: PropTypes.func,
  changeTitleAction: PropTypes.func,
  updateContactData: PropTypes.func,
  passGenerated: PropTypes.shape({ password: PropTypes.string }),
  location: PropTypes.shape({ search: PropTypes.string }),
  history: PropTypes.shape({ push: PropTypes.func }),
};

const mapStateToProps = ({ contacts, resources }) => ({
  updatedContactData: contacts.updatedContactData,
  passGenerated: contacts.passGenerated,
  contactData: contacts.contactData,
  contacts: contacts.collection,
  creatting: contacts.creatting,
  cargando: contacts.cargando,
  Communs: resources.Communs,
  loading: contacts.loading,
  total: contacts.count,
  limit: contacts.limit,
  all: contacts,
});

const mapDispatchToProps = {
  changeTitleAction,
  resetContactData,
  createContacts,
  getContacts,
  updateContactData,
  getContactData,
  updateContact,
  deleteUser,
  getRegions,
  getCommuns,
  updateCase,
  updateCaseMe,
  generatePass
};
export default connect(mapStateToProps, mapDispatchToProps)(ContactContent);
